<template>
  <!-- 投票單 列印頁 -->
  <div
    id="printVotingPaper"
    ref="printPage"
  >
    <!-- 只是六個六個一組，多一層包在外面而已 -->
    <div
      v-for="votingPaperPage in votingPaperPages"
      :key="votingPaperPage[0].barcode"
      class="votingPaperPage"
    >
      <div
        v-for="votingPaper in votingPaperPage"
        :key="votingPaper.barcode"
        class="card"
      >
        <div class="nav">
          <div class="communityArea">
            <img
              alt="voteIcon"
              class="logo"
              src="@/assets/img/unitOwnerAssembly/attendanceCard/IanLaiVote.svg"
            >
            <div class="name">
              {{ communityName }}
            </div>
          </div>
          <img
            alt="logo"
            class="smartDailyArea"
            src="@/assets/img/unitOwnerAssembly/attendanceCard/smartDaily.svg"
          >
        </div>
        <div
          v-if="1"
          class="content-container"
        >
          <div class="content">
            <div class="assemblyName">
              <span>
                {{ assemblyTitle }}
              </span>
            </div>
            <div class="topicName">
              <span>
                {{ votingPaper.title }}
              </span>
            </div>
            <div class="address">
              <span>
                {{ $t('Household.Household', {tabletNote: votingPaper.tabletName}) }}
              </span>
            </div>
            <div class="tablet">
              <span>{{ areaPerPerson }}：</span>{{ votingPaper.area }} {{ unit }}
            </div>
            <div class="dash" />
            <div class="checkbox-container">
              <div
                v-for="checkboxValue in checkboxValues"
                :key="checkboxValue"
                class="checkbox-wrapper"
              >
                <div class="checkbox" />
                <div class="checkbox-value">
                  {{ checkboxValue }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="barcode">
          <VueBarcode
            :value="votingPaper.barcode"
            :options="barcodeOptions"
            tag="img"
          />
        </div>
        <div class="footer">
          <img
            alt="footer"
            class="footerImg"
            src="@/assets/img/unitOwnerAssembly/attendanceCard/footer.svg"
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueBarcode from '@chenfengyuan/vue-barcode'
import { getBarcodeOptionsByDigit } from '../../utils/UnitOwnerAssemblyUtils'
import tw, { groupArrItems } from '../../utils'
export default {
  components: {
    VueBarcode
  },
  data () {
    const { areaPerPerson, unit } = tw
    const votingPaperPages = []
    return {
      areaPerPerson,
      unit,
      votingPaperPages,
      barcodeOptions: null,
      communityName: JSON.parse(localStorage.getItem('loginUserInfo')).CommunityName,
      attendanceCardList: [],
      topicList: [],
      votingPapers: [],
      assemblyId: '',
      assemblyTitle: '',
      checkboxValues: ['同意', '反對', '廢票']
    }
  },
  methods: {
    // 列印，要後續取得
    async print (assemblyId, assemblyTitle, topicList) {
      this.fullScreenLoading(true)
      this.assemblyId = assemblyId
      this.assemblyTitle = assemblyTitle
      this.votingPapers = []
      let res = await this.getAttendanceCardList()
      // eslint-disable-next-line eqeqeq
      if (topicList == undefined) { res = await this.getTopic() } else { this.topicList = topicList }
      if (!res) {
        this.$message({
          message: '發生未知錯誤，請稍後再試',
          type: 'warning'
        })
        this.fullScreenLoading(false)
        return
      }

      this.printData()
    },
    // 處理列印資料
    printData () {
      console.log('投票單', this.attendanceCardList)
      if (this.topicList.length < 1) {
        this.fullScreenLoading(false)
        this.$message({
          message: '此會議暫無議案',
          type: 'warning'
        })
        return
      }
      this.barcodeOptions = getBarcodeOptionsByDigit(this.attendanceCardList[0].barcode.length, 'voting')
      for (let i = 0; i < this.attendanceCardList.length; i++) {
        for (let j = 0; j < this.topicList.length; j++) {
          this.votingPapers.push({
            area: this.attendanceCardList[i].area,
            // area: (this.attendanceCardList[i].areaRatio * 100).toFixed(2).toString(),
            barcode: this.attendanceCardList[i].barcode,
            tabletName: this.attendanceCardList[i].tabletName,
            title: this.topicList[j].title
          })
        }
      }
      this.votingPaperPages = groupArrItems(this.votingPapers, 6)
      this.$nextTick(() => {
        setTimeout(() => {
          this.$print(this.$refs.printPage)
          this.fullScreenLoading(false)
        }, 300)
      })
    },
    // 取得會議條碼
    getAttendanceCardList () {
      return new Promise((resolve, reject) => {
        apiUnitOwnerAssembly.Print.GetAttendanceCardList(
          {
            AssemblyId: this.assemblyId
          }
        ).then(res => {
          if (res.status === 200) {
            this.attendanceCardList = res.data
            resolve(true)
          }
        }).catch((err) => {
          console.log('錯誤訊息：', err.response)
          if (err.response && err.response.status >= 400) {
            resolve(false)
          }
        })
      })
    },
    // 取得議案資料
    getTopic () {
      return new Promise((resolve, reject) => {
        apiUnitOwnerAssembly.Topic.GetTopicList(
          {
            AssemblyId: this.assemblyId
          }
        ).then(res => {
          if (res.status === 200) {
            this.topicList = res.data
            resolve(true)
          }
        }).catch((err) => {
          console.log('錯誤訊息：', err.response)
          if (err.response && err.response.status >= 400) {
            resolve(false)
          }
        })
      })
    },
    // 全屏loading畫面
    fullScreenLoading (display) {
      const loadingWrap = this.$loading({
        lock: true,
        text: '資料處理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      if (!display) { loadingWrap.close() }
    }
  }
}
</script>
<style lang="sass" scoped>
body
  margin: 0
@media print
  @page
    size: A4 portrait
  *
    // 父層有一個 line-height: 1 的屬性，拿掉會影響 funcWrap，有會影響列印排版
    line-height: unset !important
@media print, screen
  *
    -webkit-print-color-adjust: exact !important
  #printVotingPaper
    width: 210mm
    text-align: start
    .card
      page-break-before: always
      width: 50%
      height: calc(297mm / 3)
      display: inline-flex
      flex-direction: column
      align-items: center
      border: dashed 0.4px #e1e1e1
      box-sizing: border-box
      .nav
        display: flex
        width: 100%
        height: 43px
        justify-content: space-between
        align-items: center
        padding: 0 32px
        box-sizing: border-box
        $smartDailyAreaWidth: 80px
        .communityArea
          $logoSize: 28px
          $communityAreaGap: 8px
          flex-basis: calc( 100% - #{$smartDailyAreaWidth} )
          width: calc( 100% - #{$smartDailyAreaWidth} )
          display: flex
          align-items: center
          gap: $communityAreaGap
          .logo
            width: $logoSize
            height: 31px
          .name
            flex-basis: calc( 100% - #{$logoSize} - #{$communityAreaGap} )
            width: calc( 100% - #{$logoSize} - #{$communityAreaGap} )
            font-weight: 600
            font-size: 17px
            color: $mainFontColor
            text-overflow: ellipsis
            overflow: hidden
            white-space: nowrap
        .smartDailyArea
          flex-basis: $smartDailyAreaWidth
          width: $smartDailyAreaWidth
          height: 25.2px
      .content-container
        height: 240px
        width: 100%
        padding: 0 16px
        box-sizing: border-box
        .content
          width: 100%
          height: 100%
          border-radius: 20px
          border: solid 2px $bgDarkBg
          display: flex
          flex-direction: column
          align-items: center
          padding-top: 10px
          box-sizing: border-box
          gap: 6px
          .assemblyName
            height: 42px
            width: 100%
            display: flex
            align-items: center
            span
              padding: 0 24px
              box-sizing: border-box
              display: -webkit-box
              width: 100%
              -webkit-line-clamp: 2
              -webkit-box-orient: vertical
              overflow: hidden
              font-size: 15px
              font-weight: 600
              text-align: center
              color: $darkGrayFontColor
          .topicName
            height: 60px
            width: 100%
            display: flex
            align-items: center
            span
              padding: 0 16px
              box-sizing: border-box
              display: -webkit-box
              width: 100%
              -webkit-line-clamp: 2
              -webkit-box-orient: vertical
              overflow: hidden
              font-weight: 600
              font-size: 21px
              text-align: center
              color: $mainFontColor
          .address, .tablet
            text-overflow: ellipsis
            overflow: hidden
            white-space: nowrap
            width: 100%
            padding: 0 10px
            box-sizing: border-box
            font-weight: 600
            font-size: 17px
            text-align: center
            color: $mainFontColor
            span
              font-size: 15px
              color: $darkGrayFontColor
          .dash
            $dashMargin: 30px
            width: calc(100% - #{$dashMargin})
            margin: 0 $dashMargin
            border: 1px dashed $bgDarkBg
          .checkbox-container
            display: flex
            gap: 24px
            .checkbox-wrapper
              display: flex
              align-items: center
              gap: 8px
              .checkbox
                width: 32px
                height: 32px
                border-radius: 8px
                border: solid 3px $borderDark4
                box-sizing: border-box
              .checkbox-value
                font-weight: 600
                font-size: 25px
                text-align: left
                color: $mainFontColor
      .barcode
        width: 100%
        height: 50px
        display: flex
        justify-content: center
        align-items: center
        overflow: hidden
        margin-top: 10px
      .footer
        flex-grow: 1
        width: 100%
        display: flex
        align-items: center
        justify-content: center
        .footerImg
          height: 17px
          width: 312px
@media  screen
  #printVotingPaper
    display: none
</style>
